<!--
@component
Scope tabs shown below the command palette input. ⇄ arrow keys switch tabs
while the row is visible; the parent owns that key handling.
-->
<script lang="ts">
  import type { LucideIcon } from "@lucide/svelte";
  import clsx from "clsx";

  export interface CmdKTab {
    id: string;
    label: string;
    /** Shown before the label, selected or not. */
    icon?: LucideIcon;
  }

  type Props = {
    tabs: readonly CmdKTab[];
    selectedTab: string;
    onSelectTab: (id: string) => void;
  };

  let { tabs, selectedTab, onSelectTab }: Props = $props();
</script>

<div class="flex items-center gap-4 overflow-x-auto" role="tablist">
  {#each tabs as tab (tab.id)}
    {@const selected = tab.id === selectedTab}
    <!-- mousedown is prevented so focus stays in the search input: a focused
         tab would swallow typing and keep a stale focus ring once ←/→ moves
         the selection. -->
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      tabindex={-1}
      onmousedown={(event: MouseEvent) => event.preventDefault()}
      onclick={() => onSelectTab(tab.id)}
      class={clsx(
        "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium whitespace-nowrap",
        selected
          ? "bg-primary-selected text-primary-selected"
          : "text-primary hover:bg-primary-hover",
      )}
    >
      {#if tab.icon}
        <tab.icon size={16} class="shrink-0 icon-secondary" />
      {/if}
      {tab.label}
    </button>
  {/each}
</div>
